import { render, staticRenderFns } from "./AddToFavourite.vue?vue&type=template&id=35c42c65&scoped=true&"
import script from "./AddToFavourite.vue?vue&type=script&lang=js&"
export * from "./AddToFavourite.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/relation_btn.css?vue&type=style&index=0&id=35c42c65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c42c65",
  null
  
)

export default component.exports